<template>
    <zoe-organism-step-builder
        :steps="steps"
        :data-no-step-scroll="true"
        :allow-for-overlay="true"
    />
</template>

<script>
import ZoeOrganismStepBuilder from '../../../../../resources/components/organisms/step-builder/v1.2.0/zoe-organism-step-builder.vue';
import Default from '../../../../../../resources/frontend/js/layouts/default.vue';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ZoeStepIceBeam from '../../../../../steps/start/ice-beam/v2.1.0/main.vue';

export default {
    components: {
        ZoeOrganismStepBuilder,
    },

    layout: [Default],

    computed: {
        steps() {
            return [
                {
                    key: 'start',
                    name: 'ice-beam',
                    type: 'start',
                    version: 'v2.1.0',
                },
            ];
        },
    },
};
</script>
